module.exports = __webpack_public_path__ + "static/media/rr-2.56122e3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/rr-2.png
// module id = 120
// module chunks = 0